import { useEffect, useState } from "react";
import { Branch } from "../types/branch";

export const useUpdateVisibility = (
  formData: Branch,
  branchData: Branch | undefined,
  error: string,
  doberror: boolean
) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!branchData) {
      setVisible(false);
      return;
    }

    const branchAddr = branchData.addresses ?? {};
    const formAddr = formData.addresses ?? {};

    const hasChanges =
      branchAddr.addressLine1 !== formAddr.addressLine1 ||
      branchAddr.addressLine2 !== formAddr.addressLine2 ||
      branchAddr.postalCode !== formAddr.postalCode ||
      branchData.openingDate !== formData.openingDate ||
      branchAddr.country !== formAddr.country ||
      branchAddr.state !== formAddr.state ||
      branchAddr.city !== formAddr.city;

    const hasValidPincode = !error;
    const hasValidDate = !doberror;

    setVisible(hasChanges && hasValidPincode && hasValidDate);
  }, [formData, error, doberror, branchData]);

  return visible;
};

